import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function GoogleIcon(props) {
  return (
    <Svg
      width={17}
      height={16}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M16.33 8.18c0-.527-.047-1.027-.127-1.513H8.67v3.006h4.313a3.714 3.714 0 01-1.6 2.387v2h2.574c1.506-1.394 2.373-3.447 2.373-5.88z"
        fill={'#4285F4'}
      />
      <Path
        d="M8.67 16c2.16 0 3.967-.72 5.287-1.94l-2.574-2c-.72.48-1.633.774-2.713.774-2.087 0-3.853-1.407-4.487-3.307H1.53v2.06A7.988 7.988 0 008.67 16z"
        fill={'#34A853'}
      />
      <Path
        d="M4.183 9.527A4.642 4.642 0 013.93 8c0-.533.093-1.046.253-1.526v-2.06H1.53a7.907 7.907 0 000 7.173l2.653-2.06z"
        fill={'#FBBC05'}
      />
      <Path
        d="M8.67 3.167c1.18 0 2.233.406 3.067 1.2l2.28-2.28C12.637.793 10.83 0 8.67 0a7.988 7.988 0 00-7.14 4.413l2.653 2.06c.634-1.9 2.4-3.306 4.487-3.306z"
        fill={'#EA4335'}
      />
    </Svg>
  );
}

export default GoogleIcon;
